import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="file-input"
export default class extends Controller {
  static targets = ["input", "filename"]

  update() {
    const files = Array.from(this.inputTarget.files)
    if (files.length === 0) return

    this.filenameTarget.textContent = files.map((file) => file.name).join(", ")
    this.filenameTarget.classList.remove("text-gray-500")
    this.filenameTarget.classList.add("text-gray-900", "font-medium")
  }
}
